import { firestore } from 'firebase/app';
import { SubmissionTopic } from './Submission';

export type CurrentAndPrevious = {
  curr: number;
  prev: number;
};

export type MonitoredBlog = {
  id: string;
  name: string;
  description: string;
  url: string;
  topics: SubmissionTopic[]; // these are the all-caps IDs
  screenshotUrl: {
    s: string;
    m: string;
    l: string;
  };
  twitterHandle: string; // can probably do a client embed of their photo?
  authorName: string;
  authorImageUrl: string;

  createdAt: number;
};

export type Scores = {
  scoreLast30Days: CurrentAndPrevious;
  scoresByDay: number[];
  scoreTrend: number[];
};

export type MonitorBlogPageStats = {
  pathname: string;
  title: string;
  previewImg: string;
  rankTrend: number[];
  rankLast30Days: CurrentAndPrevious;
} & Scores;

export type MonitoredBlogWithStats = MonitoredBlog & {
  stats: {
    rankByTopicLast30Days: { [topicOrOverall: string]: CurrentAndPrevious };
    rankTrendByTopic: { [topicOrOverall: string]: number[] };
    topPages: MonitorBlogPageStats[];
    lastDateKey: string;
  } & Scores;
};

export type TopicStats = {
  topic: SubmissionTopic | 'OVERALL';
  rankLast30Days: CurrentAndPrevious;
  rankTrend: number[];
} & Scores;

export type RankingDataMetaStats = {
  blogCount: {
    OVERALL: number;
  };
};

export type RankingData = {
  blogs: MonitoredBlogWithStats[];
  statsByTopic: { [topivOrOverall: string]: TopicStats };

  metaStats: RankingDataMetaStats;
};

export type RankingStats = {
  lastDateKey: string;
  updatedAt: firestore.Timestamp;
  total: number[];
  byPage: { [pathname: string]: number[] };
};

export const STATS_RANGE = 60;
